// tslint:disable
/**
 * auto-announce-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Observable } from 'rxjs';
import type { AjaxResponse } from 'rxjs/ajax';
import { BaseAPI } from '../runtime';
import type { OperationOpts, HttpQuery } from '../runtime';

export interface AddInboundRequest {
    distance?: number;
    license?: string;
}

/**
 * no description
 */
export class CoordinateApi extends BaseAPI {

    /**
     */
    addInbound({ distance, license }: AddInboundRequest): Observable<void>
    addInbound({ distance, license }: AddInboundRequest, opts?: OperationOpts): Observable<void | AjaxResponse<void>>
    addInbound({ distance, license }: AddInboundRequest, opts?: OperationOpts): Observable<void | AjaxResponse<void>> {

        const query: HttpQuery = {};

        if (distance != null) { query['distance'] = distance; }
        if (license != null) { query['license'] = license; }

        return this.request<void>({
            url: '/coordinate/inbound',
            method: 'POST',
            query,
        }, opts?.responseOpts);
    };

    /**
     */
    getParentCarDetectionZone(): Observable<Array<Array<Array<number>>>>
    getParentCarDetectionZone(opts?: OperationOpts): Observable<AjaxResponse<Array<Array<Array<number>>>>>
    getParentCarDetectionZone(opts?: OperationOpts): Observable<Array<Array<Array<number>>> | AjaxResponse<Array<Array<Array<number>>>>> {
        return this.request<Array<Array<Array<number>>>>({
            url: '/coordinate/parent-car-detection-zone',
            method: 'GET',
        }, opts?.responseOpts);
    };

}
